import React from 'react';
import { Divider, Typography, Flex } from '@banhala/ui-kit';
import type { AlarmSettingSection } from 'shared/src/api/myPageService/getAlarmSettings/types';
import SectionItem from '../SectionItem/SectionItem';
import { isNotNil } from 'shared/src/utils';

type Props = {
  section: AlarmSettingSection;
  sectionIndex: number;
  onToggle: (sectionIndex: number, itemIndex: number) => void;
  isLastSection?: boolean;
};

const Section = ({ section, sectionIndex, onToggle, isLastSection }: Props) => {
  return (
    <Flex margin={{ bottom: 16 }}>
      <Flex margin={{ bottom: 6 }}>
        <Typography type="h4" color="content_primary">
          {section.title}
        </Typography>
      </Flex>
      {isNotNil(section.description) && (
        <Typography type="body2" color="content_tertiary">
          {section.description}
        </Typography>
      )}
      {section.alarm_list.map((item, itemIndex) => (
        <SectionItem
          key={item.push_notification_code}
          title={item.title}
          description={item.description}
          isOn={item.is_on}
          isLast={itemIndex === section.alarm_list.length - 1}
          onToggle={() => onToggle(sectionIndex, itemIndex)}
        />
      ))}

      {!isLastSection && (
        <Flex margin={{ horizontal: -16, top: 12 }}>
          <Divider size="medium" />
        </Flex>
      )}
    </Flex>
  );
};

export default Section;
